//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {fetchUser} from '@/api/user'
import {formatDate} from '@/utils/index'

export default {
  data () {
    return {
      userInfo: {},
      time: ''
    }
  },
  methods: {
    getUserInfo () {
      fetchUser().then(resp => {
        this.userInfo = resp.data
      })
    }
  },
  mounted () {
    this.getUserInfo()
    const time = new Date().valueOf() / 1000
    this.time = formatDate(time)
  }
}



// WEBPACK FOOTER //
// ./src/pages/recharge-success/index.vue